module.exports = __webpack_public_path__ + "static/tat_2-6a736841baab9d246fc5013a039d588b.jpg";